import { render, staticRenderFns } from "./index.vue?vue&type=template&id=dc72b0b0"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc72b0b0')) {
      api.createRecord('dc72b0b0', component.options)
    } else {
      api.reload('dc72b0b0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=dc72b0b0", function () {
      api.rerender('dc72b0b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/CustomerViews/ScanMvt/index.vue"
export default component.exports